import { jsx as _jsx } from "react/jsx-runtime";
import PageNavBreadcrumbs from "src/features/breadcrumbs/PageNavBreadcrumbs";
import BaseHeader from "src/pages/layout/Header";
import "./Header.scss";
const Header = () => {
    return (_jsx(BaseHeader, { className: 'reseller-clients-header', children: _jsx(PageNavBreadcrumbs, {}) }));
};
export default Header;
